import styled from 'styled-components';

export const UpgradeNowStyled = styled.div`
  .upgrade-now {
    border: 0.5px solid #8a8a8a;
    border-radius: 8px;
    padding: 6px 10px;
  }
`;
